import React, { useMemo } from 'react'
import { registerLocale } from 'react-datepicker'
import { useRunRj } from 'react-rocketjump'
import { useQsDataTable as useDataTable } from 'react-use-datatable/react'
import useQueryParams from 'magik-react-hooks/useRouterQueryParams'
import TableAttivita from '../../components/Planner/TableAttivita'
import { AttivitaAdminAutomaticaState } from './localstate/attivita'
import moment from 'moment'
import it from 'date-fns/locale/it'
import { LavorazioniState } from './localstate/lavorazioni'
import Paginator from '../../components/Paginator'
import Spinner from 'reactstrap/lib/Spinner'

import DateRangeQsFilter from '../../components/Planner/DateRangeQsFilter'
import Select from 'react-select'
import OrdersSelectAutoComplete from '../../components/OrdersSelectAutoComplete'
import { useState } from 'react'
import { useCallback } from 'react'
import ModalDeleteAttivita from '../../components/Planner/ModalDeleteAttivita'

registerLocale('it', it)
const FORMAT = 'YYYY-MM-DD'

const BIG_PAGE_PARAMS = { page_size: 1000 }

const COLOR_ACTIVITIES_LOCKED = 'rgba(0, 0, 255, 0.3)'

export default function AttivitaOperatoreAutomaticaAdmin() {
  const [queryParams] = useQueryParams()
  const [{ lavorazioni }] = useRunRj(LavorazioniState, [BIG_PAGE_PARAMS])
  const [selectedAttivita, setAttivita] = useState(null)
  const [showModalDeleteAttivita, setShowModalDeleteAttivita] = useState(false)
  const currentData = useMemo(() => {
    if (queryParams.data) {
      return new Date(queryParams.data)
    }
    return new Date()
  }, [queryParams])

  const [
    // Data State
    { attivita, pagination, loading, deleting },
    // Table state
    { page, ...filters },
    {
      // DT Actions
      onFiltersChange,
      onFilterChange,
      goToPage,
      deleteAttivita,
      refresh,
    },
  ] = useDataTable(AttivitaAdminAutomaticaState, () => ({
    operatore: '',
    lavorazione: '',
    from_data: moment(currentData).startOf('month').format(FORMAT),
    to_data: moment(currentData).endOf('month').format(FORMAT),
    lavorazioni: [],
    ordine: '',
  }))

  const lavorazioniForSelect = useMemo(() => {
    if (!lavorazioni) {
      return []
    }
    return lavorazioni.map((lavorazione) => ({
      value: lavorazione.id,
      label: lavorazione.nome,
    }))
  }, [lavorazioni])

  const selectedLavorazioni = useMemo(() => {
    if (!filters.lavorazioni || !lavorazioni) {
      return []
    }
    if (typeof filters.lavorazioni === 'string') {
      return filters.lavorazioni.split(',').map((id) => ({
        value: id,
        label: lavorazioni.find((lavorazione) => lavorazione.id === Number(id))
          .nome,
      }))
    } else {
      return filters.lavorazioni.map((id) => ({
        value: id,
        label: lavorazioni.find((lavorazione) => lavorazione.id === Number(id))
          .nome,
      }))
    }
  }, [filters.lavorazioni, lavorazioni])

  const toggleShowModalDelete = useCallback(() => {
    setShowModalDeleteAttivita((show) => !show)
  }, [setShowModalDeleteAttivita])

  return (
    <div className="container-fluid">
      {attivita === null && loading && (
        <div className="text-center mt-4">
          <Spinner color="primary" />
        </div>
      )}
      {attivita && (
        <>
          <div className="text-center d-flex justify-content-center text-primary mt-2">
            {filters.from_data || filters.to_date ? (
              <>
                {filters.from_data && (
                  <h4>Da: {moment(filters.from_data).format('DD-MM-YYYY')}</h4>
                )}
                {filters.to_data && (
                  <h4 className="ml-4">
                    A: {moment(filters.to_data).format('DD-MM-YYYY')}
                  </h4>
                )}
              </>
            ) : (
              <h4>Attività operatori</h4>
            )}
          </div>
          <div className="filters mt-2">
            <div className="row">
              <div className="col-md-3">
                <Select
                  name="lavorazioni"
                  isMulti
                  placeholder={'Filtra per lavorazioni'}
                  options={lavorazioniForSelect.filter(
                    (lavorazione) =>
                      !selectedLavorazioni.find(
                        (item) =>
                          Number(item.value) === Number(lavorazione.value)
                      )
                  )}
                  hideSelectedOptions={false}
                  value={selectedLavorazioni}
                  className="basic-multi-select select-multi-options text-nowrap w-100"
                  onChange={(newValues) => {
                    if (newValues) {
                      const items = newValues.map((item) => item.value)
                      onFilterChange(items, 'lavorazioni')
                    } else {
                      onFilterChange([], 'lavorazioni')
                    }
                  }}
                />
              </div>
              <div className="col-md-3">
                <OrdersSelectAutoComplete
                  value={filters.ordine}
                  hasValue
                  debounceTimeout={150}
                  loadOptionsOnMenuOpen
                  onChange={(ordine) => {
                    if (ordine) {
                      onFiltersChange({ ordine: ordine.id })
                    } else {
                      onFiltersChange({ ordine: '' })
                    }
                  }}
                  noOptionsMessage={() => 'Nessun ordine trovato'}
                  loadingMessage={() => 'Caricamento ordini...'}
                  placeholder={'Filtra per ordine'}
                  isClearable={true}
                  name={'ordine'}
                  additional={{
                    page: 1,
                  }}
                />
              </div>
              <div className="col-md-3">
                <DateRangeQsFilter
                  filters={filters}
                  onFiltersChange={onFiltersChange}
                  startField="from_data"
                  endField="to_data"
                  withPortal={true}
                  customArrowIcon={<div />}
                  small={false}
                  noBorder
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <TableAttivita
                attivita={attivita}
                loading={loading}
                deleteItem={deleteAttivita}
                setAttivita={setAttivita}
                setShowModalDeleteAttivita={setShowModalDeleteAttivita}
              />
              <Paginator
                numPages={pagination.numPages}
                currentPage={page}
                goToPage={goToPage}
              />
            </div>
          </div>
        </>
      )}
      {showModalDeleteAttivita && (
        <ModalDeleteAttivita
          toggle={toggleShowModalDelete}
          isOpen={showModalDeleteAttivita}
          attivita={selectedAttivita}
          
          onSetEliminato={() => {
            deleteAttivita
              .onSuccess(() => {
                toggleShowModalDelete()
                refresh()
                
              })
              .run(selectedAttivita)
          }}
        />
      )}
    </div>
  )
}
